<script>
export default {
  name: "DidoApidocUsageEntrypoint",
};
</script>

<script setup>
// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
});
</script>

<template>
  <div class="q-mt-md line-height-15">
    Le point d'entrée de l'api DiDo est :
    <a :href="props.apiUrl" title="Point d'entrée de l'api DiDo">{{
      props.apiUrl
    }}</a>
    <br /><br />
    Nous ferons référence à ce point d'entrée par la valeur
    <span class="bg-black text-white q-pa-xs">$BASE_URL_API</span>
    dans la suite de cette documentation.
  </div>
</template>
